import { Card, Tag, message, Button } from 'antd';
import Clipboard, { Event } from 'clipboard';
import { observer } from 'mobx-react';
import React, { useState, useEffect } from 'react';
import CopyIcon from '@/assets/images/icons/icon-copy.react.svg?react';
import EWeChat from '@/assets/images/public/e-wechat.svg';
import holderImg from '@/assets/images/public/no-permission.svg';
import { getPid, getProductId } from '@/infrastructure/product-info';
import {
  getAllRoles,
  getAllUsers,
  UserItem,
} from '@/presentation/pages/product/permission/api';
import { stores } from '@/presentation/store';
import { SendPermission } from './dialog/send-permission';
import { SubmitResult } from './dialog/submit-result';
import style from './index.module.scss';

export const Permission = observer(() => {
  const [permissionDialogVisible, setPermissionDialogVisible] = useState(false);
  const [submitDialogVisible, setSubmitDialogVisible] = useState(false);
  const [submitResult, setIsSubmitResult] = useState('succ');
  const [adminList, setAdminList] = useState<UserItem[]>();
  const [clipboard, setClipboard] = useState<ClipboardJS>();
  const { productId } = stores.ProductStore;

  const loadData = async () => {
    const roleArr = await getAllRoles();
    const adminRoleId = roleArr.filter(role => role.name === '管理员')?.[0]?.id;
    const allUserArr = await getAllUsers();
    const adminList = allUserArr.filter((item: UserItem) => item.roleId === adminRoleId);
    setAdminList(adminList.slice(0, 5));
  };

  useEffect(() => {
    setClipboard(new Clipboard('#copyBtn'));
    if (productId) {
      loadData();
    }
    return () => {
      clipboard?.destroy();
    };
  }, []);

  const renderAdminList = () => (
    <div className={style.memberListContainer}>
      <div>
        <span className={style.label}>链接：</span>{renderCopyText()}
      </div>
      <div className={style.memberList}>
        <span className={style.label}>管理员：</span>
        {adminList?.map?.((item: UserItem, index) => <Tag
          className={style.memberItem}
          key={item.id}
          onClick={() => window.open(`wxwork://message?username=${item.name}`)}
        >
          {item.name}<img src={EWeChat} alt={''} />{adminList?.length !== index + 1 ? '、' : ''}
        </Tag>)
        }
      </div>
    </div>
  );

  const renderCopyText = () => {
    const url = `${window.location.protocol}//${window.location.host}/v2/setting/members?productId=${getProductId()}&pid=${getPid()}${submitResult === 'succ' ? '&tabIndex=2' : ''}`;
    return <span><span>{url}</span><a
      className={style.copyIcon}
      id="copyBtn"
      data-clipboard-text={url}
      onClick={showCopyMessage}
    ><CopyIcon/></a></span>;
  };

  const showCopyMessage = () => {
    clipboard?.on('success', () => {
      message.destroy();
      message.success('复制成功');
    });
    clipboard?.on('error', (e: Event) => {
      message.destroy();
      message.error('复制失败');
      console.log('复制失败==>', e.trigger, e.action);
    });
  };

  return <Card bordered={false} style={{ flex: 1 }}>
    <div className={style.holder}>
      <img src={holderImg} alt={''} />
      <h4 className={style.subtitle}>温馨提示</h4>
      <div className={style.subDesc}>你没有该产品的访问权限，如有需要，可向管理员申请权限。</div>
      <div>
        <Button className={style.noPermissionBtn} size="large" onClick={() => window.location.href = '/'}>返回首页</Button>
        <Button
          className={style.noPermissionBtn}
          type="primary"
          size="large"
          onClick={() => setPermissionDialogVisible(true)}
        >申请加入项目</Button>
      </div>
    </div>
    <SendPermission
      permissionDialogVisible={permissionDialogVisible}
      setPermissionDialogVisible={setPermissionDialogVisible}
      setIsSubmitResult={setIsSubmitResult}
      setSubmitDialogVisible={setSubmitDialogVisible}
    />
    <SubmitResult
      renderAdminList={renderAdminList}
      submitResult={submitResult}
      submitDialogVisible={submitDialogVisible}
      setSubmitDialogVisible={setSubmitDialogVisible}
    />
  </Card>;
});
